import { FC } from 'react';

import CircularLoader from '@/components/CircularLoader.tsx';
import StatusLamp from '@/components/StatusLamp.tsx';
import Paragraph from '@/components/text/Paragraph.tsx';

import { IndicatorStatus } from '@/models/IndicatorStatus.ts';
import FormattedForm from '@/models/forms/FormattedForm.ts';
import { FormTemplate } from '@/models/forms/backend-types/form-template/FormTemplate.ts';

interface Props {
    is_loading: boolean;
    formatted_forms_for_appointment: undefined | FormattedForm[];
    professional_form_templates: undefined | FormTemplate[];
}

const DisplayForms: FC<Props> = ({ is_loading, formatted_forms_for_appointment, professional_form_templates }) => {
    const has_forms = formatted_forms_for_appointment && formatted_forms_for_appointment.length > 0;
    const has_templates = professional_form_templates && professional_form_templates.length > 0;

    if (is_loading)
        return (
            <div className="flex min-h-[4rem] w-full justify-center overflow-y-hidden p-4">
                <CircularLoader />
            </div>
        );

    if (!has_templates) {
        return (
            <Paragraph className="w-full text-sm text-slate-600">
                Für diesen Behandler sind keine Dokumente hinterlegt.
            </Paragraph>
        );
    }

    if (!has_forms) {
        return (
            <Paragraph className="w-full text-sm text-slate-600">
                Sollen für diesen Termin Dokumente ausgefüllt werden, bitte diese über &quot;Bearbeiten&quot; auswählen.
            </Paragraph>
        );
    }

    return (
        <div className="grid min-h-[4rem] w-full grid-cols-3 gap-4">
            {formatted_forms_for_appointment.map((form) => (
                <StatusLamp
                    classNames={{ text: 'w-full truncate whitespace-nowrap' }}
                    key={form.id}
                    status={form.is_completed ? IndicatorStatus.ACTIVE : IndicatorStatus.INACTIVE}
                    text={form.name}
                    tooltip
                />
            ))}
        </div>
    );
};

export default DisplayForms;
